import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { RicosEditor } from 'ricos-editor';
import { runStrategies, extractPluginsConfig, } from '@wix/ricos-common';
import './styles.global.css';
import { merge } from 'lodash';
import { runEditorStrategies } from './runEditorStrategies';
var WixRicosEditor = function (props, ref) {
    var children = props.children, biSettings = props.biSettings, instance = props.instance, plugins = props.plugins, wixExperiments = props.wixExperiments, rest = __rest(props, ["children", "biSettings", "instance", "plugins", "wixExperiments"]);
    var _rcProps = merge(runStrategies({ plugins: plugins, instance: instance, biSettings: biSettings, experiments: wixExperiments }), runEditorStrategies(plugins, instance, biSettings), extractPluginsConfig(plugins));
    return (React.createElement(RicosEditor, __assign({ _rcProps: _rcProps, ref: ref, plugins: plugins }, rest), children));
};
export default forwardRef(WixRicosEditor);
//# sourceMappingURL=WixRicosEditor.js.map